/*
 * Public API Surface of sailing-front
 */

// export * from './lib/sailing-front.service';
// export * from './lib/sailing-front.component';
// export * from './lib/sailing-front.module';
export * from './lib/sailing/sailing.module';
export * from './lib/sailing/index';
